





















































































































































































































































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { ViewpointApi, VIEWPOINT_API } from "@/api/ViewpointApi";
import BasicInputForm from "@/components/forms/BasicInputForm.vue";
import ListInput from "@/components/forms/ListInput.vue";
import SupportWindow from "@/components/common/SupportWindow.vue";
//@ts-ignore
import { NotificationEventBus } from "@/EventBus";
import Sticky from 'vue-sticky-directive';
import ConfirmationDialog from "@/components/common/ConfirmationDialog.vue";
import ScoringKeyEditor from "@/components/scoring-key/ScoringKeyEditor.vue";
import Users from "@/store/modules/Users";
import Modelling from "@/store/modules/Modelling";
import Navigation from "@/store/modules/Navigation";
import Viewpoints from "@/store/modules/Viewpoints"
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import Apps from "@/store/modules/Apps"
import ScoringKeyEditorDialog from "@/components/scoring-key/ScoringKeyEditorDialog.vue";
import { Urls } from "@/Urls";
import ViewpointNavigation from "@/components/navigation/ViewpointNavigation.vue";
import FactorNavigationWorkingModel from "@/components/navigation/FactorNavigationWorkingModel.vue";
import FactorNavigationPublishedModel from "@/components/navigation/FactorNavigationPublishedModel.vue";
import ChoiceNavigation from "@/components/navigation/ChoiceNavigation.vue";
import ScoringKeys, { ScoringKeyDefinition } from "@/store/modules/ScoringKeys";
import ChoiceVisibilitySelectorMenu from "@/components/workspace-options/ChoicesVisibilitySelectorMenu.vue";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import DecisionShareDialog from "@/components/decisions/DecisionManageUsersDialog.vue";
import CommentThreadDisplay from "@/components/comments/CommentThreadDisplay.vue";
import CommentThreadPanel from "@/components/comments/CommentThreadPanel.vue";
import ResourceEditingPanel from "@/components/panel/ResourceEditingPanel.vue";
import FactorScoringDefinitionCreatorVuexDialog
    from "@/components/scoring-definition/FactorScoringDefinitionCreatorVuexDialog.vue";
import VuexDialogScoringKeyEditor from "@/components/scoring-key/ScoringKeyEditorVuexDialog.vue";
import FactorContributionVisibilitySwitch from "@/components/workspace-options/FactorContributionVisibilitySwitch.vue";
import ChoiceInputShareDialog from "@/components/share/ChoiceInputShareDialog.vue";
import ChoiceScoreInputShareDialog from "@/components/share/ChoiceScoreInputShareDialog.vue";
import { Decision } from "@/api/model/Decision";
import { Viewpoint } from "@/api/model/Viewpoint";
import _ from "lodash";
import ModelScoringKeyButtonTrigger from "@/components/scoring-key/ModelScoringKeyButtonTrigger.vue";
import ViewpointFactorVisibilityEditorVuexDialog
    from "@/components/viewpoint-factor-visibility/ViewpointFactorVisibilityEditorVuexDialog.vue";
import AppsAddRenameDialog from "@/components/apps/AppsAddRenameDialog.vue";
import AppsAdditionalMenu from "@/components/apps/AppsAdditionalMenu.vue";
import { set } from "vue/types/umd";
import AppNavTree from "@/components/apps/AppsNavTree.vue";
import { Auth } from "aws-amplify";
import ChoiceCardDialog from '@/views/ChoiceCards/ChoiceCardDialog.vue';
import CompareViewpointDialog from '@/views/ChoiceViewpointsScorer/CompareViewpointDialog.vue';
import CompareChoiceDialog from '@/views/ViewpointChoicesScorer/CompareChoiceDialog.vue';
import DescriptionEditor from "@/components/common/DescriptionEditor.vue";
import SignUp from "@/views/Auth/SignUp.vue";
import Login from "@/views/Auth/Login.vue"
import moment from 'moment';
import CreateChoiceDialog from '@/views/ChoiceCards/ChoiceCardDialog.vue';

const usersModule = getModule(Users);
const modellingModule = getModule(Modelling);
const navigationModule = getModule(Navigation);
const viewpointsModule = getModule(Viewpoints);
const decisionsModule = getModule(Decisions);
const choicesModule = getModule(Choices);
const scoringKeysModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions);
const appsModule = getModule(Apps);

@Component({
    components: {
        ChoiceCardDialog,
        CompareViewpointDialog,
        ViewpointFactorVisibilityEditorVuexDialog,
        ModelScoringKeyButtonTrigger,
        ChoiceScoreInputShareDialog,
        ChoiceInputShareDialog,
        FactorContributionVisibilitySwitch,
        VuexDialogScoringKeyEditor,
        FactorScoringDefinitionCreatorVuexDialog,
        ResourceEditingPanel,
        CommentThreadPanel,
        CommentThreadDisplay,
        ScoringKeyEditorDialog,
        ScoringKeyEditor,
        BasicForm: BasicInputForm,
        ListInput,
        SupportWindow,
        ConfirmationDialog,
        ViewpointNavigation,
        FactorNavigationWorkingModel,
        FactorNavigationPublishedModel,
        ChoiceNavigation,
        ChoiceVisibilitySelectorMenu,
        DecisionShareDialog,
        AppsAddRenameDialog,
        AppsAdditionalMenu,
        AppNavTree,
        CompareChoiceDialog,
        SignUp,
        Login,
        CreateChoiceDialog
    },
    directives: {
        Sticky,
    },
})
export default class ViewpointAppShare extends Vue {

    @Prop({type: String, default: '1'})
    queryAppEmbedId!: string;

    @Prop({type: String, default: '1'})
    queryAppEmbedMenuId!: string;

    @Prop()
    queryActiveViewpointId!: string;

    @Prop()
    queryViewpointIds!: string[] | string;

    @Prop()
    queryDecisionId!: string;

    @Prop()
    queryChoiceId!: string;

    @Prop()
    queryShowNonContributing!: string;

    @Prop()
    queryVisibleChoices!: string[];

    @Prop()
    navDrawerProp!: boolean;

    @Prop()
    queryChoiceListIds!: string[];

    @Prop()
    queryFactorListIds!: string[];

    @Prop()
    queryActiveFactorId!: string;

    @Prop()
    queryViewpointListIds!: string[];

    @Prop()
    queryShowIconScoring!: string;

    @Prop()
    querySkipGroups!: string;

    @Prop()
    queryChoiceSort!: string;

    @Prop()
    queryChoiceNumOfCols!: string;

    @Prop()
    queryViewpointSort!: string;

    @Prop()
    queryAutocomplete!: string;

    @Prop()
    queryEnd!: string;

    @Prop()
    queryOpenRight!: string;

    @Prop()
    queryOpenLeft!: string;

    @Prop()
    queryTrimTopGroups!: string;

    @Prop()
    queryShowScores!: string;

    @Prop()
    queryShowKeys!: string;

    @Prop()
    queryShowComments!: string;

    @Prop()
    queryViewpointColumnWidth!: string;

    @Prop()
    queryChoiceColumnWidth!: string;

    @Prop()
    queryChoiceFirstCol!: string;

    @Prop()
    queryShowCustomRange!: string;

    @Prop()
    queryViewpointFirstCol!: string;

    @Prop()
    queryRankChoiceCol!: string;

    @Prop()
    queryAuthFlow!: string;

    @Prop()
    queryShowBars!: string;

    @Prop()
    queryPinnedRight!: string;

    @Prop()
    queryTemplate!: string;

    @Prop()
    queryMbDraggable!: string;

    @Prop()
    queryCreateChoice!: string;

    @Prop()
    queryDenomScoring!: string;

    @Prop()
    queryStandardize!: string;

    @Prop()
    queryChartTop!: string;

    // NEW APP CODE

    @Prop()
    queryPromote!: string;

    private doneInit = false;
    private templateViewpoint = ''
    private headers = [
        {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: 'center',
            width: 32
        },
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            width: 200
        },
        {
            text: 'Last Updated',
            align: 'start',
            value: 'lastUpdatedTimestamp',
            width: 150
        },
        {
            text: 'Creation Date',
            align: 'start',
            value: 'creationTimestamp',
            width: 150
        },
        {
            text: 'Owner',
            align: 'start',
            value: 'ownerUserId',
            width: 200
        }
    ]

    private choiceHeaders = [
        {
            text: "Actions",
            value: "actions",
            sortable: false,
            align: 'center',
            width: 32
        },
        {
            text: 'Name',
            align: 'start',
            value: 'name',
            width: 300
        }
    ]

    // private selectedApp = "";
    get apps(){
        return appsModule.appList;
    }

    get selectedApp(){
        console.log(appsModule.appId);
        // this.selectedApp = appsModule.appId;
        return appsModule.appId;;
    }
    
    set selectedApp(id:string){
        appsModule.setSelectedAppId(id);
    }

    get appsDictionary(){
        return appsModule.appsDictionary;
    }

    // Fills the APP dropdown
    get allApps(): any[] {
        if (this.apps) {
            let res: any[] = [];
            this.apps.forEach( (app: any, i: number) => {
                res.push({id: i, name: app.name});
            });
            // console.log(res);
            return res;
        }
    }

    @Watch('queryActiveViewpointId')
    private setActiveViewpointId(){
        viewpointsModule.selectActiveViewpoint(this.queryActiveViewpointId);
    }

    @Watch('queryFactorListIds')
    private onChangeFactorList(){
        workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
    }

    @Watch('queryActiveFactorId')
    private onChangeActiveFactor(){
        workspaceOptionsModule.selectBreadcrumbItem(this.queryActiveFactorId);
    }

    @Watch('queryMbDraggable')
    private onChangeMbDraggable() {
        workspaceOptionsModule.setMbDraggable(this.queryMbDraggable === 'true');
    }

    @Watch('queryDenomScoring')
    private onChangeDenomScoring() {
        if (this.queryDenomScoring != null) {
            workspaceOptionsModule.changeDenominatorScoring(this.queryDenomScoring === 'true');
        } else {
            workspaceOptionsModule.changeDenominatorScoring(false);
        }
    }

    @Watch('queryStandardize')
    private onChangeStandardize() {
        if (this.queryStandardize != null) {
            workspaceOptionsModule.changeStandardizeDenominator(this.queryStandardize === 'true');
        } else {
            workspaceOptionsModule.changeStandardizeDenominator(false);
        }
    }

    // Fills the left nav
    get appMenu() {
        // console.log(this.allApps);
        if (!this.allApps.length) return [];
        let res: any[] = [];
        if (this.appsDictionary[this.selectedApp] && this.appsDictionary[this.selectedApp].hasOwnProperty('children')) {
            res = this.appsDictionary[this.selectedApp].children;
            // console.log(res);
            return res;
        } else {
            return [];
        }
    }

    get appLabel(){
        return this.selectedApp ? "" : "Select an App";
    }

    mounted() {
        if (this.$route.path === '/') {
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            this.navTabs = 0;
        } else if (this.$route.path === this.URLS.CHOICE_SUBMITTER) {
            this.navTabs = 1;
        } else {
            this.navTabs = 2;
        }

        this.initialize();

        this.sliderPageWidth = [this.sliderLeft, this.sliderRight];

        NotificationEventBus.getEventBus().$on('choice-updated', (choice: any) => {
            choicesModule.setChoice(choice)
        });

    }

    async initialize() {
        if (this.queryDecisionId) {
            
            if (this.queryAutocomplete) {
                navigationModule.setAutocomplete(this.queryAutocomplete);
                let unauthUser: any;
                let authUser = await Auth.currentUserInfo();
                let userId: string;
 
                this.joining = true;

                await decisionsModule.selectDecision(null);
    
 
                let linkRole: string;
                if (this.queryPromote && this.queryPromote === 'true') {
                    linkRole = 'ADMIN';
                } else {
                    linkRole = 'EDIT';
                }

                if (authUser) {
                    const decisionMap: { [decisionId: string]: Decision }  = await decisionsModule.fetchDecisions();
                    userId = authUser.username;
                    
                    this.isAuthenticated = true;
                    if (decisionMap && decisionMap[this.queryDecisionId] && userId === decisionMap[this.queryDecisionId].ownerUserId) {
                        linkRole = 'OWNER';
                        
                    }
                    if (linkRole !== 'OWNER') {
                        let decisionTeam: any;
                        try {
                            decisionTeam = await VIEWPOINT_API.getDecisionUsers(this.queryDecisionId);
                            
                            let joinDecisionRole = linkRole;
                            if (decisionTeam && decisionTeam.length > 0) {
                                const decisionUser = _.find(decisionTeam, {'userId': userId});
                            
                                if (decisionUser === undefined) {
                                    let res: any = await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId, joinDecisionRole);
                            
                                } else if (decisionUser.hasOwnProperty('permissionAccess') && decisionUser.permissionAccess === 'EDIT' && joinDecisionRole === 'ADMIN') {
                                    let res: any = await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId, joinDecisionRole);
                            
                                }
                            }
                            
                        } catch(err) {
                            console.error(err);
                        }
                    }
                } else {
                    Vue.$cookies.set('app-share-url', this.$route.fullPath);
                    unauthUser = await Auth.currentCredentials();
                    userId = unauthUser.identityId;
                    navigationModule.setAnonUserId(userId);
                    let res: any = await VIEWPOINT_API.joinDecisionAutocomplete(this.queryDecisionId, userId, 'EDIT');
                }

                await decisionsModule.fetchDecisions();
                await decisionsModule.selectDecision(this.queryDecisionId);
                this.joining = false;

            }

            if (this.queryEnd && this.queryEnd.length) {
                navigationModule.setRequiredEnd(this.queryEnd);
            }

            if (this.queryViewpointIds && Array.isArray(this.queryViewpointIds) && this.queryViewpointIds.length) {
                this.queryViewpointIds.forEach(viewpointsModule.selectViewpoint);
            } else if (!Array.isArray(this.queryViewpointIds)) {
                viewpointsModule.selectViewpoint(this.queryViewpointIds);
            } else if (this.decisionViewpointsList.length > 0) {
                viewpointsModule.selectViewpoint(this.decisionViewpointsList[0].viewpointId);
            }

            if (this.queryActiveViewpointId) {
                viewpointsModule.selectActiveViewpoint(this.queryActiveViewpointId);
                if (Vue.$cookies.isKey('activeViewpointId') 
                && this.queryActiveViewpointId === Vue.$cookies.get('activeViewpointId')) 
                {
                    this.doneInit = true;
                    this.open = true;
                }
            }


            if(this.queryCreateChoice != 'true') {
                if (this.queryChoiceId) {
                    choicesModule.selectChoice(this.queryChoiceId);
                } else if (choicesModule.choiceIds.length) {
                    choicesModule.selectChoice(choicesModule.choiceIds[0]);
                }

            }
            
            if (this.queryFactorListIds != null) {
                workspaceOptionsModule.updateSavedFactorLists((typeof this.queryFactorListIds === 'string')? [this.queryFactorListIds]: this.queryFactorListIds);
            }

            if (this.queryViewpointListIds != null) {
                workspaceOptionsModule.updateSavedViewpointLists((typeof this.queryViewpointListIds === 'string')? [this.queryViewpointListIds]: this.queryViewpointListIds);
            }

            if (this.queryChoiceListIds != null) {
                workspaceOptionsModule.updateSavedChoiceLists((typeof this.queryChoiceListIds === 'string')? [this.queryChoiceListIds]: this.queryChoiceListIds);
            }

            if (this.queryChoiceSort != null) {
                workspaceOptionsModule.changeChoiceSort(parseInt(this.queryChoiceSort));
            }

            if(this.queryChoiceNumOfCols != null ) {
                workspaceOptionsModule.setNumOfCols(Number(this.queryChoiceNumOfCols));
            }

            if (this.queryViewpointSort != null) {
                workspaceOptionsModule.changeViewpointSort(parseInt(this.queryViewpointSort));
            }

            if (this.queryVisibleChoices) {
                workspaceOptionsModule.showSetChoicesOnly(this.queryVisibleChoices);
            }
            
            if (this.queryOpenLeft != null) {
                workspaceOptionsModule.setOpenLeft(this.queryOpenLeft === 'true');
            }
            if (this.queryOpenRight != null) {
                workspaceOptionsModule.setOpenRight(this.queryOpenRight === 'true');
            }

            if (this.querySkipGroups != null) {
                workspaceOptionsModule.changeSkipGroups(this.querySkipGroups === 'true');
            }

            if (this.queryShowIconScoring != null) {
                workspaceOptionsModule.changeIconScoring(this.queryShowIconScoring === 'true');
            }

            if (this.queryTrimTopGroups != null) {
                workspaceOptionsModule.changeTrimTopGroups(this.queryTrimTopGroups === 'true');
            }

            if (this.queryShowScores != null) {
                workspaceOptionsModule.setScoresVisibility(this.queryShowScores === 'true');
            }

            if (this.queryShowKeys != null) {
                workspaceOptionsModule.setKeysVisibility(this.queryShowKeys === 'true');
            }

            if (this.queryShowComments != null) {
                workspaceOptionsModule.setKeysVisibility(this.queryShowComments === 'true');
            }

            if (this.queryViewpointColumnWidth != null) {
                workspaceOptionsModule.changeViewpointColumnWidth(Number(this.queryViewpointColumnWidth));
            } else {
                workspaceOptionsModule.changeViewpointColumnWidth(200);
            }

            if (this.queryChoiceColumnWidth != null) {
                workspaceOptionsModule.changeChoiceColumnWidth(Number(this.queryChoiceColumnWidth));
            } else {
                workspaceOptionsModule.changeChoiceColumnWidth(200);
            }

            if (this.queryRankChoiceCol != null) {
                workspaceOptionsModule.setRankChoiceCol(Number(this.queryRankChoiceCol));
            } else {
                workspaceOptionsModule.setRankChoiceCol(150);
            }
            
            if (this.queryChoiceFirstCol != null) {
                workspaceOptionsModule.setChoiceFirstCol(Number(this.queryChoiceFirstCol));
            } else {
                workspaceOptionsModule.setChoiceFirstCol(600);
            }

            if (this.queryShowCustomRange != null) {
                workspaceOptionsModule.changeCustomRangeActive(this.queryShowCustomRange === 'true');
            }
            
            if (this.queryViewpointFirstCol != null) {
                workspaceOptionsModule.setViewpointFirstCol(Number(this.queryViewpointFirstCol));
            } else {
                workspaceOptionsModule.setViewpointFirstCol(600);
            }

            if (this.queryPinnedRight != null) {
                workspaceOptionsModule.setPinnedRight(this.queryPinnedRight === 'true');
            }

            if (this.queryMbDraggable != null) {
                workspaceOptionsModule.setMbDraggable(this.queryMbDraggable === 'true');
            }

            if (this.queryShowBars != null) {
            workspaceOptionsModule.setScoreBarVisibility(this.queryShowBars === 'true');
            }

            if (this.queryTemplate != null) {
                this.templateViewpoint = this.queryTemplate
            }

            if (this.queryStandardize != null) {
                    workspaceOptionsModule.changeStandardizeDenominator(this.queryStandardize === 'true');
            }

            if ( this.queryDenomScoring != null) {
                workspaceOptionsModule.changeDenominatorScoring(this.queryDenomScoring === 'true');
            }

            if ( this.queryChartTop != null ) {
                workspaceOptionsModule.setChartTop(this.queryChartTop === 'true');
            }

        }
        
        if (this.queryAutocomplete) {
            if (this.nameField) {
                setTimeout( () => {
                    // // OLD vanilla VueJS
                    // this.$refs.nameField.focus();

                    // NEW Vue Decorator Class style VueJS
                    this.nameField.focus();
                }, 500);
            }
        }

        if (this.queryAutocomplete === 'choice' && this.queryChoiceId) {
            this.joining = true;
            setTimeout( () => {
                this.joining = false;
                this.open = true;
            }, 500);
        }
        this.joining = false;
        this.initialLoad = false;

    }


    // APP SHARE CODE

    private isAuthenticated = false;
    private open = false;
    private name: string | null = null;
    private company: string | null = null;
    private companyPhone: string | null = null;
    private website: string | null = null;
    private industry: string | null = null;
    private contactName1: string | null = null;
    private contactName2: string | null = null;
    private contactJobTitle: string | null = null;
    private contactPhone: string | null = null;
    private joining: boolean | null = true;

    // NEW Vue Decorator Class style VueJS
    @Ref('nameField')
    nameField!: HTMLInputElement;

    @Ref('companyField')
    companyField!: HTMLInputElement;

    @Ref('companyPhoneField')
    companyPhoneField!: HTMLInputElement;

    @Ref('websiteField')
    websiteField!: HTMLInputElement;

    @Ref('industryField')
    industryField!: HTMLInputElement;

    @Ref('contactName1Field')
    contactName1Field!: HTMLInputElement;

    @Ref('contactName2Field')
    contactName2Field!: HTMLInputElement;

    @Ref('contactJobTitleField')
    contactJobTitleField!: HTMLInputElement;

    @Ref('contactPhoneField')
    contactPhoneField!: HTMLInputElement;

    get userDetails(): any {
        let userDetails = {
            name: this.name,
            company: this.company,
            companyPhone: this.companyPhone,
            website: this.website,
            industry: this.industry,
            contactName1: this.contactName1,
            contactName2: this.contactName2,
            contactJobTitle: this.contactJobTitle,
            contactPhone: this.contactPhone,
        }
        return userDetails;
    }

    get singularViewpointLabel() {
        return decisionsModule.singularViewpointLabel;
    }

    get pluralViewpointLabel() {
        return decisionsModule.pluralViewpointLabel;
    }

     get singularChoiceLabel() {
        return decisionsModule.singularChoiceLabel;
    }

    get pluralChoiceLabel() {
        return decisionsModule.pluralChoiceLabel;
    }

    get label(): string {
        return decisionsModule.selectedDecision && decisionsModule.selectedDecision.hasOwnProperty('choiceLabel') ? decisionsModule.selectedDecision.choiceLabel : '';
    }

    get activeChoiceList() {
        if(this.isActiveChoiceList)
            return decisionsModule.decisionLists[workspaceOptionsModule.activeChoiceLists[0]];
        else
            return [];
    }

    get activeViewpointList() {
        if(this.isActiveViewpointList)
            return decisionsModule.decisionLists[workspaceOptionsModule.activeViewpointLists[0]];
        else
            return [];
    }

    get isActiveChoiceList() {
        return (workspaceOptionsModule.activeChoiceLists?.length > 0);
    }

    get isActiveViewpointList() {
        return (workspaceOptionsModule.activeViewpointLists?.length > 0);
    }

    private continueAsGuest() {
        if (this.name.trim() !== '' && this.name !== null) {
            navigationModule.setGuestName(this.name);
            if (this.queryAutocomplete === 'choice') {
                let userDetails = this.userDetails;
                console.log('continueAsGuest() > userDetails');
                console.log(userDetails);
                this.createNewChoice();
            }
            if (this.queryAutocomplete === 'score') {
                this.createNewViewpoint();
            }
            if (this.queryAutocomplete === 'compareChoices') {
                this.createNewViewpoint();
            }
            this.open = true;
            this.doneInit = true;
        }
    }

    private continueExistingViewpoint(viewpointId: string) {
        viewpointsModule.selectActiveViewpoint(viewpointId);
        Vue.$cookies.set('activeViewpointId', viewpointId);
        this.open = true;
    }

    private continueExistingChoice(choiceId: string) {
        choicesModule.selectChoice(choiceId);
        Vue.$cookies.set('activeChoiceId', choiceId);
        this.open = true;
    }

    private createNewChoice() {
        console.log('createNewChoice');
        choicesModule.selectChoice(null);
    }

    @Watch('userId')
    private async onChangeUserId(newVal, oldVal) {
            await decisionsModule.selectDecision("")
            await this.initialize()  
            this.doneInit = true;   
    }

    private async createNewViewpoint() {
        console.log('createNewViewpoint');
        let res;
        if(this.templateViewpoint != '') {
            let originalViewpoint = viewpointsModule.decisionViewpointsMap[this.templateViewpoint]
            if(originalViewpoint?.viewpointId) {
                res = await viewpointsModule.cloneViewpoint({original: originalViewpoint, newViewpoint: {name: this.name}, includeWeights: true, includeKeys: true, includeScores: true})
            }
            else {
                res = await this.createViewpoint({
                    decisionId: this.queryDecisionId,
                    name: this.name,
                    // We could get people to add a Summary and it can go into the Description
                });
            }
        } else{     
                res = await this.createViewpoint({
                    decisionId: this.queryDecisionId,
                    name: this.name,
                    // We could get people to add a Summary and it can go into the Description
                });
            }


        if(this.queryViewpointListIds || workspaceOptionsModule.activeViewpointLists?.length > 0) {
            decisionsModule.addViewpointToActiveLists(res.viewpointId);
        }

        console.log(res);
        viewpointsModule.selectActiveViewpoint(res.viewpointId);
        // when user enter new name, store current activeViewpointId into cookie
        Vue.$cookies.set('activeViewpointId', res.viewpointId);
        // kat(may04) fix the column width is not set
        workspaceOptionsModule.resetViewpointColumnsWidth();
    }


    private readonly URLS = Urls;
    private initialLoad = true;
    private increment = 1;

    navDrawer: boolean = this.navDrawerProp;

    private loadingResources = false;
    private processing = false;

    private createDecisionDialog = false;
    private editDecisionDialog = false;
    private createViewpointDialog = false;

    private section: string = this.URLS.TEMPLATE_BUILDER;
    private fullPath: string = '';

    private staticPageWidth = [-50, 50];
    private sliderPageWidth: any[] = [];
    private sliderLeft: number = -50;
    private sliderRight: number = 50;

    private panelLeft: boolean = true;
    private navTabs: number = 0;
    private scoreTabs: string = '';

    private searchFactors: string | null = null;
    private decisionSelectorMenuShow: boolean = false;


    get isOwner(): boolean {
        return (this.userId != null) && (this.userId === this.decisionOwnerUserId);
    }

    get userId(): string | undefined {
        if (usersModule.currentUserProfile) {
            return usersModule.currentUserProfile.userId;
        }
        return undefined;
    }

    private getUserNameFromId(userId: string) {
        let user = decisionsModule.selectedDecisionUsers[userId];
        console.log(user, userId)
            return user.first || user.last ? user.first + ' ' + user.last : user.email;
    }

    private formatDate(dateString: string) {
        return moment(dateString).format('YYYY-MM-DD');
    }

    get decisionOwnerUserId(): string | undefined {
        if (decisionsModule.selectedDecision) {
            return decisionsModule.selectedDecision.ownerUserId;
        }
    }

    get scoreItems() {
        let items = [
            {text: 'Content', tooltip: '', url: this.URLS.CHOICE_SUBMITTER_EMBED             , section: this.URLS.CHOICE_SUBMITTER_EMBED},
            {text: 'Content', tooltip: '', url: this.URLS.CHOICE_CARDS_EMBED                 , section: this.URLS.CHOICE_SUBMITTER_EMBED},
            {text: 'Viewpoints', tooltip: '', url: this.URLS.WEIGHTING_EMBED                 , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Compare Content', tooltip: '', url: this.URLS.CHOICE_SCORER_COMPARE_EMBED, section: this.URLS.WEIGHTING_EMBED},
            {text: 'Compare Viewpoints', tooltip: '', url: this.URLS.CHOICE_SCORER_EMBED     , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Classify & Rank', tooltip: '', url: this.URLS.CHOICE_SCORER_BINS_EMBED   , section: this.URLS.WEIGHTING_EMBED},
            {text: 'Results', tooltip: '', url: this.URLS.RESULTS_EMBED   , section: this.URLS.WEIGHTING_EMBED},

        ];

        let decisionUsers = decisionsModule.selectedDecisionUsers
        if (this.currentUserProfile && decisionUsers[this.currentUserProfile.userId]
            && ['OWNER', 'ADMIN'].includes(decisionUsers[this.currentUserProfile.userId].permissionAccess)) {
            items.splice(0, 0, {text: 'Model', tooltip: '', url: this.URLS.TEMPLATE_BUILDER_EMBED, section: this.URLS.TEMPLATE_BUILDER_EMBED})
            if (this.$route.path === this.URLS.TEMPLATE_BUILDER_EMBED) {
                this.scoreTabs = this.URLS.TEMPLATE_BUILDER_EMBED;
            }
        }
        return items;
    }


    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get selectedFactorResourceItemId() {
        return workspaceOptionsModule.selectedPathItemId;
    }

    get draftFactorResources() {
        return modellingModule.workingModelFactorResources;
    }

    get selectedDraftFactorResourceItemId() {
        return workspaceOptionsModule.draftSelectedPathItemId;
    }

    get selectedChoiceName() {
        return this.selectedChoice ? this.selectedChoice.name : '- select one -';
    }

    get selectedViewpointName() {
        if (this.viewpoints.hasOwnProperty(this.activeViewpointId)) {
            return this.viewpoints[this.activeViewpointId].name;
        }
        return '- select one -';
    }

    get editPermissions(): boolean {
        return getModule(Choices).checkChoiceEditPermissions
    }

    get selectedFactorName() {
        if (this.$route.path === this.URLS.TEMPLATE_BUILDER) {
            if (this.selectedDraftFactorResourceItemId && this.draftFactorResources.hasOwnProperty(this.selectedDraftFactorResourceItemId)) {
                return this.draftFactorResources[this.selectedDraftFactorResourceItemId].name;
            }
        } else {
            if (this.selectedFactorResourceItemId && this.factorResources.hasOwnProperty(this.selectedFactorResourceItemId)) {
                return this.factorResources[this.selectedFactorResourceItemId].name;
            }
        }
        return '- select one -';
    }

    get viewpoints() {
        return viewpointsModule.decisionViewpointsMap || {};
    }

    get nonMapViewpoints() {
        return viewpointsModule.decisionViewpoints || []
    }

    get activeViewpointId() {
        return viewpointsModule.activeViewpointId || '';
    }

    set activeViewpointId(viewpointId: string) {
        if (viewpointId) {
            viewpointsModule.selectActiveViewpoint(viewpointId);
        }
    }

    private async selectActiveViewpoint(viewpointId: string | null = null) {
        if (viewpointId) {
            await this.selectViewpoint(viewpointId);
        }
        viewpointsModule.selectActiveViewpoint(viewpointId);
        console.log(viewpointId);
    }

    private async selectViewpoint(viewpointId: string) {
        if (viewpointId && viewpointId !== 'ROOT') {
            await viewpointsModule.selectViewpoint(viewpointId);
        }
    }

    get scoreBarVisibility() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    set scoreBarVisibility(visible: boolean) {
        workspaceOptionsModule.changeScoreBarVisibility(visible);
    }

    get currentUserProfile() {
        return usersModule.currentUserProfile;
    }

    get selectedViewpoints() {
        return viewpointsModule.selectedViewpoints;
    };

    set selectedViewpoints(selectedViewpoints: Viewpoint[] | undefined) {
        if (!selectedViewpoints) return;
        let chosenViewpointIds = selectedViewpoints.map(v => v.viewpointId);
        let viewpointsToAdd = _.pullAll(chosenViewpointIds, viewpointsModule.selectedViewpointIds);
        let viewpointsToRemove = _.pullAll(viewpointsModule.selectedViewpointIds, chosenViewpointIds);
        viewpointsToRemove.forEach(viewpointsModule.deselectViewpoint)
        viewpointsToAdd.forEach(viewpointsModule.selectViewpoint)
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision;
    }

    set selectedDecision(decision: Decision | null) {
        if (decision) {
            decisionsModule.selectDecision(decision.decisionId)
                .then(() => {
                    if (this.decisionViewpointsList && this.decisionViewpointsList.length > 0) {
                        viewpointsModule.selectViewpoint(this.decisionViewpointsList[0].viewpointId);
                    }
                    if (this.choicesList && this.choicesList.length) {
                        choicesModule.selectChoice(this.choicesList[0].id)
                    }
                    appsModule.setSelectedAppId("");
                    appsModule.fetchAppsByDecision(decision.decisionId);
                    this.$router.push({name: ''});
                    // kathy - remove following reroute functions
                    // if (this.currentUserProfile && this.selectedDecision && this.currentUserProfile.userId !== this.selectedDecision.ownerUserId) {
                    //     if (this.$route.name !== 'ChoiceSubmitter') {
                    //         this.$router.push({name: 'ChoiceSubmitter'});
                    //     }
                    // } else {
                    //     if (this.$route.name !== 'DecisionBuilder') {
                    //         this.$router.push({name: 'DecisionBuilder'});
                    //     }
                    // }
                });
        }
    }

    get panelRight() {
        return workspaceOptionsModule.rightPanelOpen;
    }

    set panelRight(value: boolean) {
        workspaceOptionsModule.setRightPanelOpen(value);
    }

    get selectedChoice() {
        return choicesModule.selectedChoice;
    };

    set selectedChoice(selectedChoice: any) {
        if (selectedChoice && selectedChoice in this.choices && this.queryCreateChoice !=  'true') {
            choicesModule.setSelectedChoiceId(selectedChoice.id);
        } else {
            choicesModule.setSelectedChoiceId(null);
        }
    }

    get decisionViewpointsList() {
        if (this.selectedDecision) {
            return decisionsModule.decisionViewpoints[this.selectedDecision.decisionId]
        }
        return [];
    }

    get decisions() {
        return _.sortBy(Object.values(decisionsModule.decisions), 'name');
    }

    get choices() {
        return choicesModule.choices;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get loading() {
        return this.loadingResources
            || this.processing
    }

    get pageWidth(): number {
        return this.sliderPageWidth[1] - this.sliderPageWidth[0];
    }

    get url() {
        return this.generateUrl();
    }


    @Watch('sliderLeft')
    sliderLeftChange(left: number) {
        if (left > -25) {
            left = -25;
        }
        this.sliderPageWidth[1] = -1 * (left);
        this.sliderRight = -1 * (left);
    }
    
    @Watch('queryChoiceId')
    private onChangeSelectedChoiceId () {
        console.log("querychoiceeeasdfasdfasdf")
        if(this.queryCreateChoice === 'true') {
            choicesModule.setSelectedChoiceId(null);
            return;
        }
        choicesModule.setSelectedChoiceId(this.queryChoiceId);
    }

    @Watch('sliderRight')
    sliderRightChange(right: number) {
        if (right < 25) {
            right = 25;
        }
        this.sliderPageWidth[0] = -1 * (right);
        this.sliderLeft = -1 * (right);
        this.$cookies.set("vp-form-width", this.sliderRight);
    }

    @Watch('navDrawer')
    navDrawerChange(newVal: boolean) {
        if (!newVal) {
            this.$emit('nav-drawer-changed', false);
        }
    }

    @Watch('navDrawerProp')
    navDrawerPropChange(newVal: boolean) {
        this.navDrawer = newVal;
        this.panelLeft = !this.panelLeft;
    }

    @Watch('$route', {immediate: true, deep: true})
    onRouteChange() {
        this.generateUrl();
    }

    private generateUrl() {
        let path = this.$router.currentRoute.path;
        let params: any = {
            viewpointIds: viewpointsModule.selectedViewpointIds,
            decisionId: decisionsModule.selectedDecisionId,
            choiceId: choicesModule.selectedChoiceId,
            activeViewpointId: viewpointsModule.activeViewpointId,
            showNonContributing: workspaceOptionsModule.contributingFactorVisibility,
            // visibleChoices: Object.keys(workspaceOptionsModule.choiceVisibility).filter((k: string) => workspaceOptionsModule.choiceVisibility[k]),
            choiceListIds: workspaceOptionsModule.activeChoiceLists,
            factorListIds: workspaceOptionsModule.activeFactorLists,
            viewpointListIds: workspaceOptionsModule.activeViewpointLists,
            activeFactorId: workspaceOptionsModule.selectedPathItemId,
            showDesc: workspaceOptionsModule.descriptionVisibility.toString(),
            showBars: workspaceOptionsModule.scoreBarVisibility.toString(),
            showIconScoring: workspaceOptionsModule.showIconScoring,
            skipGroups: workspaceOptionsModule.skipGroups,
            showNonListFactors: workspaceOptionsModule.showNonListFactors,
            viewpointSort: workspaceOptionsModule.viewpointSort,
            choiceSort: workspaceOptionsModule.choiceSort,
            openLeft: workspaceOptionsModule.openLeft.toString(),
            openRight: workspaceOptionsModule.openRight,
            choiceColumnWidth: workspaceOptionsModule.choiceColumnWidth,
            viewpointColumnWidth: workspaceOptionsModule.viewpointColumnWidth,
            choiceNumOfCols: workspaceOptionsModule.numOfCols,
            trimTopGroups: workspaceOptionsModule.trimTopGroups,
            showScores: workspaceOptionsModule.scoresVisibility.toString(),
            showKeys: workspaceOptionsModule.keysVisibility.toString(),
            showComments: workspaceOptionsModule.commentsVisibility.toString(),
            choiceFirstCol: workspaceOptionsModule.choiceFirstCol,
            showCustomRange: workspaceOptionsModule.customRangeActive.toString(),
            viewpointFirstCol: workspaceOptionsModule.viewpointFirstCol,
            rankChoiceCol: workspaceOptionsModule.rankChoiceCol,
            pinnedRight: workspaceOptionsModule.pinnedRight,
            autocomplete:this.queryAutocomplete,
            template: this.templateViewpoint,
            mbDraggable: workspaceOptionsModule.mbDraggable.toString(),
            denomScoring: workspaceOptionsModule.denominatorScoring.toString(),
            standardize: workspaceOptionsModule.standardizeDenominator.toString(),
            createChoice: this.queryCreateChoice,
            chartTop: this.queryChartTop
        };
        if (Object.values(params).filter(f => f).length > 0) {
            path = path + '?'
            for (let p in params) {
                if (params[p] && params[p] != null) {
                    if (Array.isArray(params[p]) && params[p].length > 0) {
                        path = path + (params[p] as any[]).map(v => p + '=' + v).join('&') + '&'
                    } else if (!Array.isArray(params[p])) {
                        path = path + p + '=' + params[p] + '&';
                    }
                }
            }
            path = path.substring(0, path.length - 1);
        }

        //@ts-ignore
        history.pushState({}, null, path);
        this.fullPath = path;
        this.$emit('new-path', path);
        return path;
    }

    private recenterSlider(value: any[]) {
        if (value[0] > (-25)) {
            value[0] = -25;
            this.sliderPageWidth[0] = -25;
        }
        this.sliderLeft = value[0];
        if (value[1] < (25)) {
            value[1] = 25;
            this.sliderPageWidth[1] = 25;
        }
        this.sliderRight = value[1];
    }

    private async createViewpoint(viewpoint: any) {
        this.emitProcessingMessage();
        this.createViewpointDialog = false;
        try {
            if (this.selectedDecision) {
                let res: any = await decisionsModule.createDecisionViewpoint({
                    decisionId: this.selectedDecision.decisionId,
                    name: viewpoint.name,
                    description: viewpoint.description
                })
                this.emitSuccessMessage();
                return res;
            }
            if (this.queryDecisionId) {
                let res: any = await decisionsModule.createDecisionViewpoint({
                    decisionId: viewpoint.decisionId,
                    name: viewpoint.name,
                    description: viewpoint.description
                })
                this.emitSuccessMessage();
                return res;
            }
            
        } catch (err) {
            this.emitFailedMessage(err);
            return err;
        }
        return;
    }

    private async createDecision(decisionInput: any) {
        this.createDecisionDialog = false;
        this.emitProcessingMessage();
        let newDecision = await decisionsModule.createDecision({
            name: decisionInput.name,
            description: decisionInput.description
        });
        await decisionsModule.selectDecision(newDecision.decisionId)
        this.emitSuccessMessage();
    }

    private async deleteDecision(decisionId: string) {
        await decisionsModule.deleteDecision(decisionId)
    }

    private async editDecision(payload: Decision) {
        this.editDecisionDialog = false;
        NotificationEventBus.emitProcessingMessage();
        try {
            await decisionsModule.updateDecision(payload);
            NotificationEventBus.emitSuccessMessage();
        } catch (err) {
            NotificationEventBus.emitFailedMessage(err);
        }
    }

    private emitProcessingMessage() {
        this.processing = true;
        NotificationEventBus.emitProcessingMessage()
    }

    private emitSuccessMessage() {
        this.processing = false;
        NotificationEventBus.emitSuccessMessage()
    }

    private emitFailedMessage(error: any) {
        this.processing = false;
        NotificationEventBus.emitFailedMessage(error);
    }

    private updateScoringKeyDefinition(scoringKeys: any[]) {
        let scoringKeyDefinition: ScoringKeyDefinition | null;
        if (scoringKeys == null || scoringKeys.length === 0) {
            scoringKeyDefinition = null;
        } else {
            scoringKeyDefinition = {
                scoringKeys: scoringKeys,
                notApplicableEnabled: false
            }
        }
        NotificationEventBus.emitProcessingMessage();
        scoringKeysModule.updateDecisionScoringKeyDefinition(scoringKeyDefinition)
            .then(() => {

            })
            .catch((error: any) => {
                NotificationEventBus.emitFailedMessage({message: error.message});
            });
    }


}
